import React from 'react'
import request from 'superagent'
import PropTypes from 'prop-types'
// import moment from 'moment'
import R from 'ramda'
import {
  Form,
  Button
} from 'semantic-ui-react'

import {
  AUTH_API_URL
} from '_constants'

import {
  TYPES,
  MECHANISMS
} from '../../../server/constants'

import {SingularSearch as UserSearch} from '_forms/userSearch'

const sendRequest = (url, payload, callback) => request.post(url)
  .withCredentials()
  .set('Content-Type', 'application/json')
  .accept('json')
  .send(payload)
  .end((err, res) => {
    if (err || R.has('error', R.prop('body', res))) {
      const errMsg = R.path(['body', 'error'], res) || R.path(['response', 'body', 'error'], err) || err
      return callback(errMsg)
    }
    return callback()
  })

const needsSubWarning = R.compose(
  R.both(
    R.pathEq(['activated_info', 'mechanism'], MECHANISMS.FASTSPRING),
    R.propEq('type', TYPES.SUBSCRIPTION)
  ),
  R.defaultTo({}),
  R.prop('license')
)

const getUserError = props => needsSubWarning(props)
  ? 'Please make sure the users are aware of (and agree to) any rebilling when transfering a subscription. If the sub is canceled in Fastspring, no rebilling will occur. The original owner is able to cancel the sub at any time.'
  : null

class Transfer extends React.PureComponent {
  state = {
    selections: [],
    isTransferLoading: false,
    isUnclaimLoading: false
  }
  onTransfer = () => {
    const user = R.path(['state', 'selections', 0], this)
    const license = R.path(['props', 'license'], this)
    if (!(user && R.has('_id', user))) {
      return window.alert('No user selected')
    }
    if (!(license && R.has('_id', license))) {
      return window.alert('No license selected')
    }
    this.setState({isTransferLoading: true})
    const url = `${AUTH_API_URL}/licenses/${license._id}/transfer`
    sendRequest(url, {user_id: user._id}, (errMsg) => {
      if (errMsg) {
        this.setState({isTransferLoading: false})
        return window.alert(errMsg)
      }
      // don't filter any responses
      this.setState({selections: [], isTransferLoading: false})
      this.props.onTransferLicense(user)
    })
  }

  onUnclaim = () => {
    const license = R.path(['props', 'license'], this)
    if (!(license && R.has('_id', license))) {
      return window.alert('No license selected')
    }
    const url = `${AUTH_API_URL}/licenses/${license._id}/unclaim`
    if (window.confirm('Set this license to be unclaimed?')) {
      this.setState({isUnclaimLoading: true})
      sendRequest(url, {user_id: null}, (errMsg) => {
        if (errMsg) {
          this.setState({isUnclaimLoading: false})
          return window.alert(errMsg)
        }
        // don't filter any responses
        this.setState({isUnclaimLoading: false})
        this.props.onTransferLicense(null)
      })
    }
  }

  onAcChange = (_selections, sel) => sel && sel._id
    ? this.setState({selections: [sel]})
    : this.setState({selections: []})

  render () {
    return (
      <Form size='tiny'>
        <Form.Group>
          <UserSearch
            width={16}
            labelTxt='Transfer license to:'
            popupTxt='Type to search users. On submit, the license will transfer to the selected user.'
            placeholder='Type to search users, license will transfer here...'
            onChange={this.onAcChange}
            error={getUserError(this.props)}
          />
        </Form.Group>
        <Form.Group>
          <Form.Field width={16}>
            <Button.Group>
              <Button onClick={this.props.onCancel}>Cancel</Button>
              <Button.Or />
              <Button positive loading={this.state.isTransferLoading} onClick={this.onTransfer}>Transfer</Button>
            </Button.Group>
          </Form.Field>
        </Form.Group>
        <Form.Group>
          <Form.Field width={16}>
            <Button size='mini' loading={this.state.isUnclaimLoading} onClick={this.onUnclaim}>Set Unclaimed</Button>
          </Form.Field>
        </Form.Group>
      </Form>
    )
  }
}

Transfer.propTypes = {
  license: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onTransferLicense: PropTypes.func.isRequired
}

export default Transfer



// WEBPACK FOOTER //
// ./webAdmin/views/license/transfer.js